<template>
  <div class="content text-center mx-auto">
    <div class="body-content">
      <div
        class="d-flex flex-column justify-content-center align-items-center title-content"
      >
        <p v-if="!isNotSelling" class="top-head font-weight-bold fs-14">Thank you {{ vehicleInfo.customerName }} for enquiring about <br v-if="isMobile" /> selling your car with AutoFlip.</p>
        <p v-else class="top-head font-weight-bold fs-14">Thank you {{ vehicleInfo.customerName }} for your enquiry on AutoFlip.</p>
        <div class="d-flex flex-column justify-content-center align-items-center desc">
          <p class="bottom-head font-weight-bold fs-14">WHAT TO EXPECT NEXT?</p>
          <p v-if="!isNotSelling" class="desc-content font-weight-thin fs-12">Before your car is officially listed for sale, a member <br v-if="isMobile" /> 
          of our customer service team will contact you within <br v-if="isMobile" /> the next <br v-if="!isMobile" /> business day. They'll confirm a few details, <br v-if="isMobile" /> 
          answer any questions and then go to work to get you <br v-if="isMobile" /> the best price, fast.</p>
          <p v-else class="desc-content font-weight-thin fs-12">
            If you're interested in selling, a member of our
            <br v-if="isMobile" />
            customer service team will contact you within the next
            <br v-if="isMobile" />
            business day. They will <br v-if="!isMobile" />
            discuss our sale process, <br v-if="isMobile" />
            confirm a few details, answer any questions and then
            <br v-if="isMobile" />
            go to work to get you the best price, fast.
          </p>
        </div>
      </div>
      <div class="bg-white pt-30 main-content">
        <div class="info-vehicle">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              item
              mx-auto
              mb-2
            "
          >
            <p class="mb-0 font-weight-thin">RESERVE PRICE:</p>
            <p class="mb-0 price">{{ reservePrice }}</p>
          </div>
          <div
            class="d-flex justify-content-between align-items-center item mx-auto"
          >
            <div class="d-flex justify-content-center align-items-center year">
              <p class="fs-14 text-white mb-0">{{ vehicleInfo.year }}</p>
            </div>
            <p class="mb-0">{{ vehicleInfo.make }} {{ vehicleInfo.model }}</p>
          </div>
        </div>
        <vehicle-slide></vehicle-slide>
        <div class="vehicle mx-auto">
          <vehicle-condition :vehicleInfo="vehicleInfo"></vehicle-condition>
          <vehicle-detail :vehicleInfo="vehicleInfo"></vehicle-detail>
        </div>
        <div class="text-note px-2 mb-0">
          Something not quite right?<br />
          <span>No problem, simply email
            <a href="mailto:info@autoflip.com.au" style="color: inherit; text-decoration: underline;">info@autoflip.com.au</a>
          and we'll update your info.</span>
        </div>
      </div>
    </div>
    <how-we-work></how-we-work>
    <FAQs></FAQs>
  </div>
</template>

<script>
import VehicleSlide from "@/components/thanks-page/VehicleSlide";
import VehicleCondition from "@/components/thanks-page/VehicleCondition";
import VehicleDetail from "@/components/thanks-page/VehicleDetails";
import HowWeWork from "@/components/thanks-page/HowWeWork";
import FAQs from "@/components/thanks-page/FAQs";

export default {
  name: "Index",
  data() {
    return {
      vehicleInfo: { ...this.$store.getters.curVehicleInfo },
      isMobile: true,
    };
  },
  computed: {
    reservePrice() {
      return (
        "$" + new Intl.NumberFormat().format(this.vehicleInfo.reservePrice)
      );
    },
    mobileMediaQuery: function() { 
      return window.matchMedia('(min-width: 768px)');
    },
    isNotSelling: function() {
      return this.vehicleInfo.sell === "I'm not selling";
    }
  },
  components: {
    VehicleSlide,
    VehicleCondition,
    VehicleDetail,
    HowWeWork,
    FAQs,
  },
  mounted() {
    // Check mobile screen
    this.mobileMediaQuery.addListener(e => {
      if (e.matches) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    });

    this.isMobile = !this.mobileMediaQuery.matches;
  },
};
</script>

<style lang="scss">
.content {
  color: #404040;

  .body-content {
    margin-bottom: 10px;

    .title-content {
      height: 243px;
      margin-top: 5px;
      background-color: #242B2F;
      padding: 0 10px;

      .top-head {
        color: #2BB673;
        line-height: 20px;
      }

      .desc {
        .bottom-head {
          color: #2BB673;
          line-height: 20px;
          text-transform: uppercase;
        }
        .desc-content {
          color: white;
        }
      }
    }

    .main-content {
      padding-bottom: 28px;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;

      .item {
        max-width: 314px;
        height: 40px;
        background-color: #f1f1f1;
        border-radius: 10px;
        padding: 0 12px;

        .year {
          width: 60px;
          height: 25px;
          background-color: #00b66c;
          border-radius: 5px;
        }

        .price {
          color: #00b66c;
        }
      }

      .text-note {
        color: #00C44B;
        font-size: 14px;
        text-align: left;
        max-width: 354px;
        margin-top: 17px;
        span {
          color: black !important;
        }
      }
    }
  }
  .lean-info {
    padding-bottom: 30px;
  }
}

@media screen and (min-width: 768px) {
  .body-content {
    margin-bottom: 20px !important;
  }
  .title-content {
    margin: 0 auto;
    .top-head {
      font-size: 24px !important;
      line-height: 44px !important;
    }
    .desc {
      margin-top: 8px !important;
      .bottom-head {
        font-size: 24px !important;
        line-height: 44px !important;
      }
      .desc-content {
        font-size: inherit !important;
      }
    }
  }
  .main-content {
    padding-bottom: 20px !important;
    .info-vehicle {
      display: flex;
      justify-content: space-between;
      flex-direction: row-reverse;
      max-width: 655px;
      margin: 0 auto;

      .item {
        min-width: 280px;
        margin: 0 !important;
        padding: 0 22px !important;

        .price {
          font-size: 20px !important;
        }
      }

    }
    .vehicle {
      max-width: 980px;
      display: flex;
      justify-content: space-between;
    }
    .text-note {
      max-width: 980px !important;
      margin-top: 17px !important;
      margin-left: auto;
      margin-right: auto;
      padding: 0 !important;
    }
  }
  .lean-info {
    margin: 0;
    width: 100%;
    max-width: unset;
    .title-info {
      padding-top: 20px;
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
  .main-content {
    .vehicle-non-slide {
      max-width: 600px !important;
    }
    .vehicle-slide {
      max-width: 625px !important;
    }
    .vehicle {
      display: block !important;
      justify-content: unset !important;
      .vehicle-condition {
        margin: 0 auto !important;
        width: 100% !important;
        max-width: 515px !important;
        .vehicle-condition-wrapper {
          flex-direction: column !important;
          .vehicle-condition-item {
            margin: 0 auto !important;
            transform: scale(1.1);
          }
        }
      }
      .vehicle-detail {
        margin: 0 auto !important;
        width: 100% !important;
        max-width: 515px !important;
        margin-top: 50px !important;
      }
    }
    .text-note {
      margin-left: 5px !important;
    }
  }
}
@media screen and (min-width: 992px) and (max-width: 1199px) {
  .vehicle {
    .vehicle-condition {
      margin-left: 5px !important;
    }
    .vehicle-detail {
      margin-right: 5px !important;
    }
  }
}
@media screen and (min-width: 767px) and (max-width: 992px) {
  .title-content .top-head {
    font-size: 22px !important;
    line-height: 22px !important;
    padding-top: 15px !important;
  }
}

@media screen and(min-width: 1200px) {
  .title-content {
    max-width: 1120px;
  }
  .lean-info .type-info {
    max-width: 1050px !important;
    margin: 0 auto;
  }
}
</style>
